// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
let AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AgentInfo__Jsx3 = require("../../uikit/reason/atoms/AgentInfo/AgentInfo__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let VerifiedAgentCardV5_Agent_graphql = require("../../__generated__/VerifiedAgentCardV5_Agent_graphql.bs.js");
let VerifiedAgentCardV5_Chapter_graphql = require("../../__generated__/VerifiedAgentCardV5_Chapter_graphql.bs.js");
let VerifiedAgentCardV5_sharedProperty_graphql = require("../../__generated__/VerifiedAgentCardV5_sharedProperty_graphql.bs.js");
let VerifiedMemberLogoSvg = require("../../../assets/images/verified-member-logo.svg");

let verifiedMemberLogo = VerifiedMemberLogoSvg;

function VerifiedAgentCardV5$Display(props) {
  let logo = JsxRuntime.jsx("img", {
    className: "block w-[154px] h-[34px] md:w-[264px] md:h-[58px]",
    alt: "Top Agent Network Verified Member",
    src: verifiedMemberLogo
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.title,
        className: "text-[22px] text-zinc-700 font-medium leading-none"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: props.agentInfo,
            className: "shrink-0"
          }),
          JsxRuntime.jsx("div", {
            children: logo,
            className: "hidden lg:flex flex-grow justify-end self-start"
          })
        ],
        className: "mt-5 flex flex-col items-start lg:flex-row lg:items-center"
      }),
      JsxRuntime.jsx("div", {
        children: props.bodyText,
        className: "text-zinc-600 text-[14px] leading-[1.5] mt-5"
      }),
      JsxRuntime.jsx("div", {
        children: logo,
        className: "flex lg:hidden mt-5"
      })
    ],
    className: "py-[20px]"
  });
}

let Display = {
  make: VerifiedAgentCardV5$Display
};

let convertFragment = VerifiedAgentCardV5_Agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, VerifiedAgentCardV5_Agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(VerifiedAgentCardV5_Agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, VerifiedAgentCardV5_Agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(VerifiedAgentCardV5_Agent_graphql.node, convertFragment, fRef);
}

let AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = VerifiedAgentCardV5_Chapter_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, VerifiedAgentCardV5_Chapter_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(VerifiedAgentCardV5_Chapter_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, VerifiedAgentCardV5_Chapter_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(VerifiedAgentCardV5_Chapter_graphql.node, convertFragment$1, fRef);
}

let ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function VerifiedAgentCardV5(props) {
  let match = RescriptRelay_Fragment.useFragment(VerifiedAgentCardV5_Agent_graphql.node, convertFragment, props.agent);
  let profilePhoto = match.profilePhoto;
  let displayName = match.displayName;
  let chapter = useOpt$1(props.chapter);
  let avatar = profilePhoto !== undefined ? profilePhoto.sidecardUrl : AvatarSrcUrl.place_holder;
  let chapter$1 = Stdlib_Option.flatMap(chapter, c => c.displayName);
  return JsxRuntime.jsx(VerifiedAgentCardV5$Display, {
    agentInfo: JsxRuntime.jsx(AgentInfo__Jsx3.make, {
      avatar: avatar,
      size: "large",
      name: displayName,
      brokerage: match.brokerage,
      children: JsxRuntime.jsx("a", {
        children: JsxRuntime.jsx(View__Jsx3.make, {
          mt: "sm",
          children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            size: "small",
            icon: "comment",
            children: `Contact ` + displayName
          })
        }),
        href: "mailto:" + Scalars.EmailAddress.toString(match.emailAddress)
      })
    }),
    title: "Courtesy of",
    bodyText: `Top Agent Network ` + Stdlib_Option.getOr(chapter$1, "") + ` is a private, online community for the verified top 10% of real estate agents in your area. Members share buyer and seller needs to give their clients a competitive edge in the market.`
  });
}

let convertFragment$2 = VerifiedAgentCardV5_sharedProperty_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, VerifiedAgentCardV5_sharedProperty_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(VerifiedAgentCardV5_sharedProperty_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, VerifiedAgentCardV5_sharedProperty_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(VerifiedAgentCardV5_sharedProperty_graphql.node, convertFragment$2, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function VerifiedAgentCardV5$FromSharedProperty(props) {
  let match = RescriptRelay_Fragment.useFragment(VerifiedAgentCardV5_sharedProperty_graphql.node, convertFragment$2, props.sharedProperty);
  let chapter = Stdlib_Option.flatMap(match.property, p => Stdlib_Option.map(p.chapter, c => c.fragmentRefs));
  return VerifiedAgentCardV5({
    chapter: chapter,
    agent: match.sender.fragmentRefs
  });
}

let FromSharedProperty = {
  Fragment: Fragment,
  make: VerifiedAgentCardV5$FromSharedProperty
};

let make = VerifiedAgentCardV5;

exports.verifiedMemberLogo = verifiedMemberLogo;
exports.Display = Display;
exports.AgentFragment = AgentFragment;
exports.ChapterFragment = ChapterFragment;
exports.make = make;
exports.FromSharedProperty = FromSharedProperty;
/* verifiedMemberLogo Not a pure module */
